import { createFileRoute } from "@tanstack/react-router";
import HeroSection from "@/components/cbfeo/HeroSection";
import AboutSection from "@/components/cbfeo/AboutSection";
import SponsorsSection from "@/components/cbfeo/SponsorsSection";
import AudienceSection from "@/components/cbfeo/AudienceSection";
import VenueSection from "@/components/cbfeo/VenueSection";
import SpeakersSection from "@/components/cbfeo/SpeakersSection";
import ScheduleSection from "@/components/cbfeo/ScheduleSection";

import GallerySection from "@/components/cbfeo/GallerySection";
import FAQSection from "@/components/cbfeo/FAQSection";
import RealizacaoSection from "@/components/cbfeo/RealizacaoSection";
import AoVivoCta from "@/components/cbfeo/AoVivoCta";
import FooterSection from "@/components/cbfeo/FooterSection";
import "@/styles/cbfeo.css";

const CBFEO_FAQ = [
  { q: "Quem pode participar do CBFEO?", a: "Você não precisa ser nosso aluno. O CBFEO é um congresso aberto ao público, embora as inscrições sejam iniciadas com prioridade para alunos da Fisio em Ortopedia. O evento é exclusivo para fisioterapeutas e estudantes de Fisioterapia, em função do nível técnico-científico das discussões." },
  { q: "Quando as inscrições do II CBFEO serão abertas?", a: "As inscrições estão previstas para serem abertas em 20 de maio de 2026. Essa data poderá sofrer ajustes conforme a organização do evento. Recomendamos entrar na lista de espera para receber as atualizações em primeira mão." },
  { q: "Sugestões de hospedagem?", a: "Recomendamos os hoteis do grupo Ibis. O mais próximo do evento é o Ibis São Paulo Tatuapé, que fica cerca de 7 min de carro do local do congresso." },
  { q: "O Congresso terá certificado?", a: "Sim. Todos os participantes receberão certificado impresso com carga horária referente aos dois dias de evento. O documento será entregue no último dia do congresso." },
  { q: "Ainda não sou formado(a) em fisioterapia, posso participar?", a: "Sim, pode (e deve), se seu interesse for a área da musculoesquelética." },
  { q: "Haverá venda de ingressos no dia do evento?", a: "Não garantimos. As vagas são limitadas a 400 participantes e, na edição anterior, foram totalmente preenchidas em cerca de duas semanas." },
  { q: "Vou ter acesso ao conteúdo depois?", a: "Depende do ingresso que você escolher. O acesso ao replay completo será oferecido em uma opção separada." },
  { q: "Onde poderei tirar dúvidas e conversar sobre o congresso em tempo real?", a: "Uma vez que a sua inscrição seja confirmada, você receberá o convite para participar da comunidade FEO. Lá, terá acesso à um espaço para retirar suas dúvidas e conectar com outros membros." },
  { q: "Como funcionará a política de cancelamento?", a: "Caso você precise cancelar a sua inscrição, o prazo para solicitar o reembolso é de até 7 (sete) dias corridos após a data da compra, conforme o Código de Defesa do Consumidor." },
];

export const Route = createFileRoute("/cbfeo")({
  head: () => ({
    meta: [
      { title: "II CBFEO 2026 | Congresso de Fisioterapia em Ortopedia" },
      { name: "robots", content: "noindex, nofollow, noarchive" },
      { name: "description", content: "II Congresso Brasileiro de Fisioterapia em Ortopedia e Traumatologia. 18 e 19 de setembro de 2026, em São Paulo. 400 vagas presenciais." },
      { property: "og:title", content: "II CBFEO 2026 | Congresso Brasileiro de Fisioterapia em Ortopedia" },
      { property: "og:description", content: "Dois dias de imersão com os maiores nomes da fisioterapia ortopédica do Brasil." },
      { property: "og:type", content: "website" },
      { name: "twitter:title", content: "II CBFEO" },
      { name: "twitter:description", content: "Dois dias com os maiores nomes da fisioterapia ortopédica do Brasil." },
    ],
  }),
  component: CbfeoPage,
});


function CbfeoPage() {
  return (
    <div className="cbfeo-scope">
      <main className="min-h-screen">
        
        <HeroSection
          ctaHref="#cronograma"
          ctaLabel="CRONOGRAMA"
          showHeadline={false}
        />

        <div id="sobre">
          <AboutSection />
        </div>
        <SponsorsSection />
        <AudienceSection />
        <VenueSection ctaHref="#cronograma" ctaLabel="CRONOGRAMA" />
        <SpeakersSection />
        <div id="cronograma">
          <ScheduleSection />
        </div>

        <AoVivoCta />

        <GallerySection />
        <FAQSection />
        <RealizacaoSection />
        <FooterSection />
      </main>
    </div>
  );
}

